import http from 'utils/http';
import type { SingleResponse } from 'interface/service';

import { INFO_URL } from 'constants/endpoints';

/**
 * Fetch the info for the logged in user.
 *
 * @returns {Promise}
 */
export async function fetchInfo<T = unknown>() {
  const { data } = await http.get<SingleResponse<T>>(INFO_URL);

  return data;
}
